// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__FpqEZ","wrapper-disabled":"styles_wrapper-disabled__CSjFt","icon":"styles_icon__+s0tr","drag-handle":"styles_drag-handle__Zf9c2"};